// extracted by mini-css-extract-plugin
export var startRoundContainer = "StartRound-module--startRoundContainer--1cHv_";
export var playsFirst = "StartRound-module--playsFirst--1RLXI";
export var startRoundButton = "StartRound-module--startRoundButton--3TId7";
export var backButton = "StartRound-module--backButton--2407p";